import { FilterHandlerBase } from './base/filter-handler-base';
import { AdvancedFilterName, FilterPassParams } from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { OptionsType } from '../../issue/maturity';
import { filterPrice } from '../../../grid/utils/filter/maturities-filters';
import { BasicMaturity } from '../../../types/deal.types';

export class PriceAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.price;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const price = params.filters[this.name];
    const data = params.deal;
    const isPriceFilterPassed: boolean = price
      ? !!(
          ((!data.maturities || data.maturities.length === 0) &&
            price.model.values &&
            price.model.values.indexOf(OptionsType.Blank) !== -1) ||
          (data.maturities &&
            data.maturities.filter((mat: BasicMaturity) =>
              filterPrice(result, data.id, price, mat)
            ).length > 0)
        )
      : true;
    result.applyDealFilerResult(data.id, this.name, isPriceFilterPassed);

    return isPriceFilterPassed;
  }
}
